export default {
  common: {
    account: '账户',
    agents: '代理',
    all: '全部',
    available: '可用',
    cancel: '取消',
    cloud: '云端',
    copy: '复制',
    current: '当前',
    delete: '删除',
    error: '错误',
    export: '导出',
    help: '帮助',
    home: '首页',
    language: '语言',
    links: '链接',
    loading: '加载中',
    local: '本地',
    login: '登录',
    logout: '退出登录',
    metadata: '元数据',
    more: '更多',
    name: '名称',
    never: '从不',
    none: '无',
    notes: '备注',
    ok: '确定',
    open: '打开',
    password: '密码',
    project: '项目',
    projects: '项目',
    publicLink: '公开链接',
    register: '注册',
    remove: '移除',
    save: '保存',
    search: '搜索',
    settings: '设置',
    subscribe: '订阅',
    track: '音轨',
    tracks: '音轨',
    unknown: '未知',
    unknownArtist: '未知艺术家',
    upload: '上传',
    username: '用户名'
  },
  time: {
    day: '天',
    days: '天',
    daysAgo: (ctx) => `${ctx.named('count')} 天前`,
    hoursAgo: (ctx) => `${ctx.named('count')} 小时前`,
    minutesAgo: (ctx) => `${ctx.named('count')} 分钟前`,
    rightNow: '刚刚',
    duration: (ctx) => {
      const minutes = Number(ctx.named('minutes'))
      const seconds = Number(ctx.named('seconds'))
      if (minutes > 0) return `${minutes} 分钟 ${seconds} 秒`
      return `${seconds} 秒`
    }
  },
  topBar: {
    accountFallback: '账户',
    storage: '存储',
    language: '语言'
  },
  commandPalette: {
    placeholder: '搜索音轨和项目...',
    projects: '项目',
    tracks: '音轨',
    pages: '页面',
    noResults: '没有找到结果',
    quickLinks: '快捷链接',
    page: {
      home: '首页',
      account: '账户',
      agents: '代理',
      links: '链接',
      settings: '设置',
      help: '帮助'
    }
  },
  explorer: {
    searchTitle: '搜索',
    trackCount: (ctx) => `${ctx.named('count')} 个音轨`
  },
  emptyState: {
    hello: '你好',
    addTrack: '添加音轨',
    addTrackSubtitle: '开始使用',
    dragDrop: '拖放',
    dragDropSubtitle: '快速上传你的文件',
    switchStorage: '切换',
    switchStorageSubtitle: '在顶部菜单中切换云端和本地',
    installAgent: '安装代理',
    installAgentSubtitle: '自动上传你的文件',
    playTrack: '播放音轨',
    playTrackSubtitle: '打开底部播放器来使用效果',
    community: '有问题？加入我们的 {discord} 和 {telegram} 社区。'
  },
  create: {
    createProject: '创建项目',
    uploadTrack: '上传音轨',
    newProject: '新项目',
    artist: '艺术家',
    name: '名称',
    create: '创建',
    loading: '加载中...',
    uploadCover: '上传封面'
  },
  upload: {
    ariaLabel: '上传音轨',
    uploadTrack: '上传音轨',
    analyzing: '分析中...',
    fileAdded: '文件 "{name}" 已添加',
    fileReadError: '文件读取错误。',
    errorWithMessage: '错误：{message}'
  },
  dragDrop: {
    dropToUpload: '松开以上传',
    deleteDrop: '松开这里可永久删除音轨'
  },
  project: {
    upload: '上传',
    noTracks: '没有音轨',
    createdBy: '创建者',
    trackSummary: (ctx) => `${ctx.named('count')} 个音轨，${ctx.named('duration')}`,
    play: '播放',
    pause: '暂停'
  },
  trackItem: {
    more: '更多',
    copyPublicLink: '复制公开链接',
    savedLocally: '已保存到本地',
    saveLocal: '保存到本地存储',
    saving: '保存中...',
    saveCloud: '保存到云端',
    deleteTrack: '删除音轨',
    moveUp: '上移',
    moveDown: '下移',
    removeFromProject: '从 {project} 中移除',
    moveToProject: '移动到项目',
    currentProject: '（当前）',
    confirmDelete: '确定要删除这个音轨吗？',
    linkCopiedTitle: '链接已复制',
    linkCopiedDescription: '公开链接已复制到剪贴板'
  },
  trackView: {
    created: '创建于 {time}',
    tabs: {
      notes: '备注',
      metadata: '元数据'
    },
    notFound: '找不到音轨或你无权访问',
    untitled: '未命名'
  },
  notes: {
    placeholder: '添加关于这个音轨的备注...',
    saving: '保存中...',
    saveError: '无法保存备注。请重试。'
  },
  metadata: {
    trackOrder: '音轨顺序',
    artist: '艺术家',
    name: '名称',
    key: '调性',
    mode: '模式',
    deleteTrack: '删除音轨',
    saveError: '无法保存元数据。请重试。'
  },
  lufs: {
    momentary: '瞬时 LUFS',
    shortTerm: '短期 LUFS',
    integrated: '综合 LUFS'
  },
  effects: {
    pitchshift: '变调',
    speed: '速度',
    balance: '平衡',
    volume: '音量',
    reverberation: '混响',
    distortion: '失真',
    bitcrush: '位深压缩',
    saveCurrentEffectsAs: '将当前效果保存为',
    presetName: '名称',
    add: '添加',
    availablePresets: '可用预设',
    tune: '调音',
    eq: 'EQ',
    fx: 'FX',
    presets: '预设',
    center: '居中',
    left: '左',
    right: '右'
  },
  exportPanel: {
    applyEffects: '应用当前效果',
    applyEffectsSubtitle: '导出带有当前效果的音轨',
    exportWav: '导出为 WAV',
    exportMp3: '导出为 MP3',
    exporting: '导出中...',
    exportAsNewTrack: '导出为新音轨',
    creatingTrack: '创建音轨中...',
    downloadOriginal: '下载原文件',
    originalUnavailable: '原始文件不可用。',
    downloadOriginalFailed: '无法下载原始文件。',
    exportAudioFailed: '无法导出音轨音频。',
    waveformFailed: '无法生成波形。',
    createTrackFailed: '无法创建导出的音轨。',
    createTrackAlert: '无法创建导出的音轨：{message}',
    exportedSuffix: '（导出）',
    copySuffix: '（副本）'
  },
  publicLink: {
    copy: '复制',
    open: '打开',
    linkCopiedTitle: '链接已复制',
    linkCopiedDescription: '公开链接已复制到剪贴板'
  },
  settings: {
    tabs: {
      settings: '设置',
      account: '账户',
      links: '链接',
      agents: '代理'
    },
    display: '显示',
    language: '语言',
    showBpm: '在音轨视图中显示 BPM',
    showBpmSubtitle: '在音轨列表中显示每个音轨的每分钟节拍数',
    showLufs: '在音轨视图中显示 LUFS',
    showLufsSubtitle: '在音轨列表中显示每个音轨的响度单位',
    showKey: '在音轨视图中显示调性',
    showKeySubtitle: '在音轨列表中显示每个音轨的调性和模式',
    playback: '播放',
    liveLoudness: '实时响度计量',
    liveLoudnessSubtitle: '在播放器界面显示实时响度表',
    persistEffects: '为所有音轨保留已应用效果',
    persistEffectsSubtitle: '切换音轨时仍保留已应用效果',
    keyboardShortcuts: '键盘快捷键',
    search: '搜索',
    pressShortcut: '按下想要的按键组合',
    storage: '存储',
    resetPresetsInfo: '重置此浏览器中保存的所有预设',
    resetPresets: '重置预设',
    resetAllWarning: '警告！下面的按钮会删除本地存储中的所有数据。',
    resetAllData: '重置本地存储并删除所有音轨和项目',
    loadingAccount: '账户加载中...',
    loadingLinks: '链接加载中...',
    loadingAgents: '代理加载中...',
    authPrompt: '登录或注册后即可使用此部分。',
    loginRegister: '登录或注册',
    pageTitle: {
      settings: '设置',
      account: '账户设置',
      links: '公开链接',
      agents: '代理'
    },
    presetsCleared: '预设存储已清空',
    localDataDeleted: '所有本地数据已删除',
    linkCopied: '链接已复制',
    linkCopyFailed: '无法复制链接'
  },
  account: {
    hello: '你好，{name}。',
    subscriptionStatus: '你的订阅当前为 {status}',
    noSubscription: '你没有有效订阅。',
    manageSubscription: '管理订阅和付款方式',
    subscribeCloud: '订阅以使用云端',
    changeUsername: '更改用户名',
    changePassword: '更改密码',
    saveUsername: '保存用户名',
    savePassword: '保存密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    usernamePlaceholder: '你的用户名',
    storageUsage: '存储使用量',
    baseStorage: '基础存储',
    subscriptionStorage: '订阅存储',
    used: '已用',
    available: '可用',
    deletedFilesNotice: '如果你最近删除了文件，它们可能仍会计入这些指标。几小时内会更新。',
    accountId: '账户 id',
    currentPeriodEnds: (ctx) => `当前付款周期将在 ${ctx.named('count')} ${ctx.named('label')} 后结束`,
    accessEnds: (ctx) => `订阅访问将在 ${ctx.named('count')} ${ctx.named('label')} 后结束`,
    lastPaymentEnded: (ctx) => `上一个付款周期已于 ${ctx.named('date')} 结束`,
    previousBillingDate: '上一个账单日期',
    billingPortalError: '账单门户错误',
    billingPortalFailed: '无法打开账单门户。',
    loginRequiredUpdate: '你需要登录才能更新个人资料。',
    usernameEmpty: '用户名不能为空。',
    usernameUnchanged: '用户名未更改。',
    usernameUpdated: '用户名已更新',
    usernameUpdateFailed: '无法更新用户名。请重试。',
    passwordEmpty: '密码不能为空。',
    passwordsMismatch: '密码不匹配。',
    passwordUpdated: '密码已更新',
    passwordUpdateFailed: '无法更新密码。请重试。'
  },
  links: {
    title: '公开链接',
    description: '你的所有公开链接都列在这里。任何拥有访问权限的人都可以收听项目或音轨。',
    cloudOnly: '公开链接仅在云端模式下可用。切换到云端存储即可创建和管理公开链接。',
    noLinks: '没有可用的公开链接',
    createFirst: '创建你的第一个公开链接以开始分享。',
    confirmDelete: '确定要删除这个链接吗？',
    notFoundTitle: '链接未找到或已过期',
    notFoundDescription: '你访问的链接无效或已过期。',
    unknownUser: '未知'
  },
  agents: {
    authorizeTitle: '授权代理',
    authorizeDescription: '允许此代理连接到你的账户。',
    loginToAuthorize: '请登录以授权此代理。',
    wantsConnect: '此代理想连接到你的账户，以自动上传音频文件。',
    permissionUpload: '上传音轨',
    permissionMetadata: '创建音轨元数据',
    authorize: '授权',
    cancel: '取消',
    authorizedTitle: '代理已授权',
    authorizedDescription: '现在可以关闭此窗口并返回代理应用。',
    desktopTitle: '桌面代理',
    installDescription: '在 PC 或 Mac 上安装 demoparty 代理，以自动上传你刚渲染的音轨。',
    warningLabel: '警告：',
    alphaWarning: '代理仍处于 alpha 状态，可能不稳定。',
    downloadMacApple: '下载 Mac Apple Silicon 版本',
    downloadMacIntel: '下载 Mac Intel 版本',
    downloadWindows: '下载 Windows x64 版本',
    signingNotice: '这些构建尚未数字签名，因为项目仍在开发中。启动时出现安全警告是正常的。签名构建将在之后提供。',
    activeTitle: '活动代理',
    connectedDescription: '连接到你账户的代理。',
    loginToManage: '请登录以管理你的代理。',
    noAgents: '尚未连接代理。',
    lastUsed: '上次使用',
    revoke: '撤销',
    remove: '移除',
    confirmRemove: '确定要移除此代理吗？',
    authorizeFailed: '无法授权代理。请重试。'
  },
  login: {
    intro: '如果想使用云端功能和订阅权益，你需要登录。否则，你可以免费在本地使用此服务。',
    subscriptionBenefits: '订阅权益',
    login: '登录',
    register: '注册',
    forgot: '我忘记了密码',
    email: 'e-mail',
    password: '密码',
    repeatPassword: '重复密码',
    or: '或',
    google: '使用 Google 登录',
    apple: '使用 Apple 登录',
    resetPassword: '重置密码',
    resetDescription: '我们会发送登录链接，方便你设置新密码。',
    sendResetLink: '发送重置链接',
    invalidToken: '令牌无效或已过期',
    enterEmail: '请输入你的 e-mail',
    resetSent: '如果账户存在，我们已向你的 e-mail 发送登录链接。',
    resetFailed: '无法发送重置链接。请重试。'
  },
  googleCallback: {
    wait: '请稍等，正在登录...'
  },
  subscribe: {
    cloudRequiredTitle: '需要云端存储',
    cloudRequiredMessage: '此功能仅在云端存储并拥有有效订阅时可用。',
    title: '先从本地开始。升级以自动上传。',
    description: '云端可让你的资料库在设备之间同步。',
    localFree: '你可以在本地模式免费使用应用。',
    cloudIncludes: '云端包含',
    featureLibrary: 'Web 和 iPhone 间同步的统一资料库',
    featureAgent: '桌面代理自动上传新的渲染文件',
    featureStorage: '100 GB 音轨云端存储',
    featureLinks: '用于音轨和项目的持久公开链接',
    featureTools: '包含所有本地分析、效果和导出工具',
    monthly: '月付',
    monthlyDescription: '云端同步，可随时取消',
    yearly: '年付',
    yearlyDescription: '云端同步的最佳性价比',
    saveTen: '节省 10%',
    perMonth: '/月',
    billedMonthly: '按月计费',
    billedYearly: '每年收费 $53.89',
    openingCheckout: '正在打开 checkout...',
    subscribePlan: '订阅 {plan}',
    registerSubscribe: '注册并订阅',
    securePayment: '通过 Polar 安全付款。可随时在账户设置中取消。',
    customPlan: '需要自定义方案或有疑问？请联系我们：',
    privacy: '隐私政策',
    terms: '服务条款',
    refund: '退款政策',
    checkoutFailed: '无法创建 checkout。请重试。'
  },
  thanks: {
    title: '感谢你的订阅！',
    description: '现在你可以使用云端存储了。若要管理订阅，请查看账户页面。',
    startWorking: '开始工作',
    communities: '加入我们的社区',
    support: '如果遇到任何问题，请通过 {email} 或上方社区链接联系我们。'
  },
  help: {
    title: '帮助',
    intro: 'demoparty 是用于未完成音乐和进行中项目的工作区。你可以存储 demo、应用效果、编辑标签并跟踪技术元数据。本地使用完全免费。',
    uploadTitle: '上传',
    uploadText: '你可以点击主页上的 Add 按钮添加音轨。上传过程中，系统会自动检测调性、BPM 和 LUFS。上传完成后，你会收到确认通知。',
    storageTitle: '存储',
    storageText: 'demoparty 提供两种存储选项：本地和云端。',
    localStorageText: '本地存储只把所有数据保存在你的设备上。音轨和项目仅在上传它们的浏览器中可用。存储使用 IndexedDB。不需要注册，也不会发送任何数据。',
    cloudStorageText: '云端存储会将你的数据保存在 demoparty 服务器上。你可以随时随地访问音轨。需要注册和有效订阅。',
    agentsTitle: '代理',
    agentsText: '使用云端存储时，你可以安装桌面代理。代理会自动把新渲染的音轨上传到云端。',
    publicLinksTitle: '公开链接',
    publicLinksText: '云端用户可以为音轨和项目创建公开链接。在项目页面点击链接按钮。对于音轨，请使用音轨下拉菜单中的相同图标。所有生成的链接都可在设置中管理。',
    exportTitle: '导出',
    exportText: '音轨可以带着所有已应用效果导出。打开音轨页面并选择导出。你可以下载原始文件，或将其导出为 MP3/WAV。',
    supportTitle: '支持',
    supportText: "如果有 demoparty 云端订阅相关问题，请通过 support{'@'}demoparty.app 联系我们。",
    attributionsTitle: '致谢',
    attributionsText: '以下库让这个项目成为可能。感谢各自的开发者。'
  },
  cover: {
    upload: '上传封面',
    change: '更换封面',
    delete: '删除封面',
    loading: '加载中...',
    selectImage: '请选择图片文件',
    uploadError: '封面上传错误'
  }
}
